// Phase-boundary timing for the sign-in-to-first-model path.
//
// Every boundary calls mark(); the viewer's `load` event calls report(), which
// prints one console.table of each phase's offset from boot and its gap from
// the previous mark. Marks are always recorded -- they cost nothing and show
// up in the DevTools Performance panel in production -- but the table prints
// only in dev, so a run is one copy-paste into the OGScan Load Study run log.
const PREFIX = 'og:';

export function mark(name) {
  if (
    typeof performance !== 'undefined' &&
    typeof performance.mark === 'function'
  ) {
    performance.mark(PREFIX + name);
  }
}

export function report() {
  if (!import.meta.env.DEV) return;
  if (typeof performance === 'undefined') return;
  const marks = performance
    .getEntriesByType('mark')
    .filter((m) => m.name.startsWith(PREFIX));
  if (marks.length === 0) return;
  const t0 = marks[0].startTime;
  const rows = marks.map((m, i) => ({
    phase: m.name.slice(PREFIX.length),
    'ms from boot': Math.round(m.startTime - t0),
    'ms since prev':
      i === 0 ? 0 : Math.round(m.startTime - marks[i - 1].startTime),
  }));
  console.table(rows);
}
